export const INTEGRATIONS_MODE = {
  ASANA_ADD: 'ASANA_ADD',
  ASANA_UPDATE: 'ASANA_UPDATE',
  ASANA_REMOVE: 'ASANA_REMOVE'
}
